module.exports = __webpack_public_path__ + "img/178.a0e31e3c.jpg";